import { useFormikContext } from "formik";
import { ConfigTabState } from "../types";
import { LabeledInput } from "../../../Components/ConfigurationTab/LabeledInput";
import { UnitAdornment } from "../../../Components/ConfigurationTab/UnitAdornment";
import { QUANTITY_UNIT } from "../../../megawatts";
import { SETTINGS_LABEL_PLACEMENT } from "./constants";

const non_negative_number_regex = (decimals: number) =>
  "[0-9]+[,.]?[0-9]{0," + decimals + "}";
const quantity_regex = non_negative_number_regex(1);

export const QuantityField = (props: {
  inputRef: React.RefObject<HTMLInputElement | null>;
}) => {
  const { inputRef } = props;
  const { setFieldValue, values, errors } = useFormikContext<ConfigTabState>();

  const calculate_updated_quantity = (
    value: string | number | undefined,
    traded: number | undefined
  ) => {
    let parsed = value;
    if (typeof parsed === "string") {
      parsed = parseFloat(parsed.replace(",", ".").replace(/[^0-9.]/g, ""));
      if (isNaN(parsed)) {
        return value;
      }
    }
    return (parsed ?? 0) + (traded ?? 0);
  };
  const setValue = (
    value: number | string | undefined,
    traded: number | undefined
  ) => {
    const calculated = calculate_updated_quantity(value, traded);
    console.log("setting new quantity to:", calculated);
    setFieldValue("quantity", calculated);
    setFieldValue("display_quantity", value);
  };
  return (
    <LabeledInput
      required
      key={"QuantityField"}
      label="Quantity"
      labelPlacement={SETTINGS_LABEL_PLACEMENT}
      error={Boolean(errors.quantity)}
      type="text"
      name="quantity"
      onChange={(e) => {
        setValue(e.target.value, values.traded_quantity);
      }}
      value={format_display_quantity(values.display_quantity)}
      endAdornment={<UnitAdornment unit={QUANTITY_UNIT} />}
      // `inputRef` reaches the same DOM node the old `inputProps.ref` did, so
      // `focusField` still lands here on open.
      inputRef={inputRef}
      inputProps={{
        pattern: quantity_regex,
        step: ".1",
      }}
      autoComplete="off"
    />
  );
};

const format_display_quantity = (value: number | string | undefined | null) => {
  if (value === undefined || value === null) {
    return "";
  }
  if (value === 0) {
    return "";
  }
  if (typeof value === "string") {
    return value.replace(",", ".").replace(/[^0-9.]/g, "");
  }
  return value.toFixed(1);
};
